import React from "react";
import translate from '../locales/progress';
import Img from "../components/image";
import gif from '../assets/images/gif/licorne.gif';

function Progress() {

    return (
        <div className="progress">
            <div className="large container medium-padding-vertical cols-2">
                <Img lazySrc="https://site-cbc.radio-canada.ca/site/edi/gem-load-grise.gif" src={gif} alt={translate.alt} legend={translate.legend} />
                <div className="content-right">
                    <h2 className="purple">{translate.title}</h2>
                    <p>{translate.content}</p><br/>
                    <button className="button"><a href={translate.link} target="_blank" rel="noreferrer">{translate.button}</a></button>
                </div>
            </div>
        </div>
    )
}

export default Progress;